import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Card, Icons, Label, TBody, TD, TH, THead, TR, Table, Toggle } from '@sede-enterprise/shell-ds-react-framework';

import { Col, Row } from '../../components/flexbox/Flex';
import { AnchorSpan, ContainerDiv } from '../../components/styledComponent/StyledComponent';
import { ApiUrls } from '../../helpers/ApiUrls';
import { formatDateToDDMMMYYYY, usePageTitle, downloadFile } from '../../services/UtilService';
import './styles.css';
import { getData } from '../../services/ApiService';
import ResponseErrorModal from '../../components/responseErrorModal/ResponseErrorModal';
import BackButton from '../../components/backButton/BackButton';
import Loader from '../../components/loader/Loader';
import { APIErrorResponseInterface } from '../../helpers/InterfacesConstants';
import { useTranslation } from 'react-i18next';


interface DataObj{
    tcNumber: string,
    idocNum: string | null,
    ticketDetail: [{
        ticketNumber: string,
        ticketType: string | null,
        batchNumber: number,
        deliveryId: number,
        site: string,
        grossQuantity: number,
        totalQuantity: number,
        transactionDate: string,
        receivedDate: string,
        uom: string | null,
        fileName: string,
        transactionStatus: string,
        isRawdata: boolean,
        createdBy: string | null,
        createdDate: string | null,
        modifiedBy: string | null,
        modifiedDate: string | null,
    }],
    productDetails: [
        {
            ambientTemperature: string | null,
            code: string | null,
            confirmedQuantity: number | null,
            confirmedUOM: string | null,
            density: number | null,
            name: string | null,
            packTypeCode: number | null,
            storedTemperature: string | null,
            quantity: number | null,
            uom: string | null,
            type: string | null,
            isRawdata: boolean
        }
    ],
    flightDetail: [{
        aircraftRegistration: string,
        finalDestination: string | null,
        flightId: string | null,
        flightOccurNumber: number,
        nextDestination: string,
        isRawdata: boolean
    }],
    customerTransactionDetail: [{
        customer: string,
        customerCode: string,
        conco: string,
        delco: string,
        customerAccountNumber : string | null,
        cardNumber: number | null,
        extInd: string | null,
        creditType: string | null,
        dutyInd: string | null,
        transactionType: string | null,
        vatInd: string | null,
        isRawdata: boolean
    }],
    feesDetails: [{
        code: string | null,
        name: string | null,
        quantity: string | null,
        isRawdata: boolean
    }],
    fileDetails:[{
        fileUploadedBy : string | null,
        fileUploadedDate:  string | null,
        attachmentFileName:  string | null,
        remarks: string | null,
        blobFileName: string | null,
        reason: string | null
    }]
}


interface fileDetail{
    fileUploadedBy : string | null,
    fileUploadedDate:  string | null,
    attachmentFileName:  string | null,
    remarks: string | null,
    blobFileName: string | null,
    reason: string | null
}

const RawDetails = () => {
    const transaction  = useParams();
    const [data, setData] = useState<DataObj | null>();
    const [isLoading, setIsLoading] = useState(true);
    const [innerActive, setActive] = useState(true);
    const [apiErrorResponse, setApiErrorResponse] = useState<APIErrorResponseInterface | null>();

    const { t } = useTranslation();
    usePageTitle(t('shellAviationAIMS')+" | Details");

    const download = (fileDetail: fileDetail) =>{
        const url = ApiUrls.fileDownload + '/' + transaction.headerId + '/' +fileDetail.blobFileName + '/'+fileDetail.reason;
        const fileName = fileDetail.attachmentFileName ? fileDetail.attachmentFileName : 'temp';
        downloadFile(url, fileName);
    }
    
    useEffect(() => {
        const url = ApiUrls.details + transaction.headerId;
        setIsLoading(true);
        getData(url).then((response) => {
            if (response) {
                setData(response.data);
                setIsLoading(false);
            }
        }).catch((error)=>{
            setApiErrorResponse({
                message : error.response.data.message,
                traceId : error.response.data.traceId
            });
        });
    }, []);

    const handleCopyID = () => {
        const copyID: string  = data?.ticketDetail[0].ticketNumber?  data?.ticketDetail[0].ticketNumber : '';
        navigator.clipboard.writeText(copyID);
    };
    return (
        <>

            {isLoading && <Loader/>}
            <ContainerDiv>
                <Row>
                    <Col> 
                        <BackButton/>
                    </Col>
                </Row>
                <Row>
                    <Col size="40"> 
                        <h2 style={{margin:'0px'}}>Ticket# {data?.ticketDetail[0].ticketNumber}
                            <Button variant="transparent" icon={<Icons.Copy />} onClick={handleCopyID} style={{minWidth:'auto'}}></Button>
                        </h2>    
                    </Col>
                    <Col size="60">
                        <Row>
                            <Col size="40">
                                <Label bold>Trade Control Approval ID: </Label>
                                {data?.tcNumber}
                            </Col>
                            <Col size="40">
                                <Label bold>Operational Status: </Label>
                                {data?.ticketDetail[0].transactionStatus}
                            </Col>

                            <Col size="20">
                                <Toggle  label="View Raw Data" mirrored defaultChecked={innerActive} onClick={() => setActive(!innerActive)}/>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                
            </ContainerDiv>



            <ContainerDiv>
                <Card>
                    <Table size="small" align="left"  width="100%" >
                        <THead>
                            <TR>
                                <TH>Received Date</TH>
                                <TH>Transaction Date</TH>
                                <TH>Ticket Type</TH>
                                <TH>Delivery ID</TH>
                                <TH>Site</TH>
                                <TH>Gross Qty</TH>
                                <TH>Net Qty</TH>
                                <TH>UOM</TH>
                            </TR>
                        </THead>
                        <TBody>
                        
                            {data?.ticketDetail.map((detail, index) => (
                                
                                
                            <TR key={index} className={detail.isRawdata ? 'disabled' :''}>
                                {(innerActive || !detail.isRawdata) && (
                                    <>
                                        <TD>{formatDateToDDMMMYYYY(detail.receivedDate)}</TD>
                                        <TD>{formatDateToDDMMMYYYY(detail.transactionDate)}</TD>
                                        <TD>{detail.ticketType}</TD>
                                        <TD>{detail.deliveryId}</TD>
                                        <TD>{detail.site}</TD>
                                        <TD>{detail.grossQuantity}</TD>
                                        <TD>{detail.totalQuantity}</TD>
                                        <TD>{detail.uom}</TD>
                                    </>
                                )}
                                
                                
                            </TR>
                            
                            ))}
                            
                        </TBody>
                    </Table>
                </Card>
            </ContainerDiv>


            <ContainerDiv>
                <Card  header={{
                    title: 'Flight Details',
                    }}
                    >
                    <Table size="small" align="left"  width="100%" >
                        <THead>
                            <TR>
                                <TH>Flight ID</TH>
                                <TH>Aircraft Registration</TH>
                                <TH>Next Destination</TH>
                                <TH>Final Destination</TH>
                                <TH>Flight Occur Number</TH>
                            </TR>
                        </THead>
                        <TBody>

                            {data?.flightDetail.map((fDetail, index) => (
                            <TR key={index} className={fDetail.isRawdata ? 'disabled' :''}>
                                {(innerActive || !fDetail.isRawdata) && (
                                <>
                                    <TD>{fDetail.flightId}</TD>
                                    <TD>{fDetail.aircraftRegistration}</TD>
                                    <TD>{fDetail.nextDestination}</TD>
                                    <TD>{fDetail.finalDestination}</TD>
                                    <TD>{fDetail.flightOccurNumber}</TD>
                                </>
                                )}
                            </TR>
                            ))}
                        </TBody>
                    </Table>
                </Card>
            </ContainerDiv>

            <ContainerDiv>
                <Card header={{
                    title: 'Customer & Transaction Details',
                    }}>
                    <Table size="small" align="left"  width="100%" >
                        <THead>
                            <TR>
                                <TH>Customer</TH>
                                <TH>Account Number</TH>
                                <TH>Conco</TH>
                                <TH>Delco</TH>
                                <TH>Transaction Type</TH>
                                <TH>Card Number</TH>
                                <TH>Credit Type</TH>
                                <TH>Vat Ind</TH>
                                <TH>Duty Ind</TH>
                            </TR>
                        </THead>
                        <TBody>
                            {data?.customerTransactionDetail.map((custDetail, index) => (
                            <TR key={index} className={custDetail.isRawdata ? 'disabled' :''}>
                                {(innerActive || !custDetail.isRawdata) && (
                                <>
                                <TD>{custDetail.customer} {custDetail.customerCode && <span>({custDetail.customerCode})</span>}</TD>
                                <TD>{custDetail.customerAccountNumber}</TD>
                                <TD>{custDetail.conco}</TD>
                                <TD>{custDetail.delco}</TD>
                                <TD>{custDetail.transactionType}</TD>
                                <TD>{custDetail.cardNumber}</TD>
                                <TD>{custDetail.creditType}</TD>
                                <TD>{custDetail.vatInd}</TD>
                                <TD>{custDetail.dutyInd}</TD>
                                </>
                                )}
                            </TR>
                            ))}
                        </TBody>
                    </Table>
                </Card>
            </ContainerDiv>

            <ContainerDiv>
                <Card header={{
                    title: 'Product Details',
                    }}>
                    <Table size="small" align="left"  width="100%" >
                        <THead>
                            <TR>
                                <TH>Product Code</TH>
                                <TH>Name</TH>
                                <TH>Qty</TH>
                                <TH>UOM</TH>
                                <TH>Ambient Temperature</TH>
                                <TH>Stored Temperature</TH>
                                <TH>Density</TH>
                            </TR>
                        </THead>
                        <TBody>
                            {data?.productDetails.map( (product, index) => (
                                <TR key={index} className={product.isRawdata ? 'disabled' :''}>
                                    {(innerActive || !product.isRawdata) && (
                                    <>
                                        <TD>{product.code}</TD>
                                        <TD>{product.name}</TD>
                                        <TD>{product.quantity}</TD>
                                        <TD>{product.uom}</TD>
                                        <TD>{product.ambientTemperature}</TD>
                                        <TD>{product.storedTemperature}</TD>
                                        <TD>{product.density}</TD>
                                    </>
                                    )}
                                </TR>
                            ))}
                        </TBody>
                    </Table>
                </Card>
            </ContainerDiv>

            <ContainerDiv>
                <Card header={{
                    title: 'Fees',
                    }}>
                    <Table size="small" align="left"  width="100%" >
                        <THead>
                            <TR>
                                <TH>Code</TH>
                                <TH>Name</TH>
                                <TH>Qty</TH>
                            </TR>
                        </THead>
                        <TBody>
                        {data?.feesDetails.map( (feeDetail, index) => (
                            <TR key={'fee' + index} className={feeDetail.isRawdata ? 'disabled' : ''}>
                                {(innerActive || !feeDetail.isRawdata) && (
                                <>
                                    <TD>{feeDetail.code}</TD>
                                    <TD>{feeDetail.name}</TD>
                                    <TD>{feeDetail.quantity}</TD>
                                </>
                                )}
                            </TR>
                        ))}
                        </TBody>
                    </Table>
                </Card>
            </ContainerDiv>
            
            <ContainerDiv>
                <Card header={{
                    title: 'Files & Comments',
                    }}>
                    <Table style={{tableLayout: 'fixed'}} >
                        <THead>
                            <TR>
                                <TH style={{width: '30%'}}>File Name</TH>
                                <TH style={{width: '40%'}}>Comment</TH>
                                <TH style={{width: '15%'}}>Updated By</TH>
                                <TH style={{width: '15%'}}>Updated Date</TH>
                            </TR>
                        </THead>
                        <TBody className="file-table-body">
                        {data?.fileDetails.map( (fileDetail, index) => (
                            <TR key={'file'+''+index}>
                                <TD><AnchorSpan onClick={()=>{download(fileDetail)}}>{fileDetail?.attachmentFileName && fileDetail.attachmentFileName}</AnchorSpan></TD>
                                <TD>{fileDetail?.remarks}</TD>
                                <TD>{fileDetail?.fileUploadedBy}</TD>
                                <TD style={{textAlign: 'end'}}>{fileDetail?.fileUploadedDate && formatDateToDDMMMYYYY(fileDetail.fileUploadedDate)}</TD>
                            </TR>
                        ))}
                        </TBody>
                    </Table>
                </Card>
            </ContainerDiv>


            <ContainerDiv>
                <Card header={{
                    title: 'Created & Modified Details',
                    }}>
                    <Table style={{tableLayout: 'fixed'}} >
                        <THead>
                            <TR>
                                <TH style={{width: '25%'}}>Created By</TH>
                                <TH style={{width: '25%'}}>Created Date</TH>
                                <TH style={{width: '25%'}}>Last Modified By</TH>
                                <TH style={{width: '25%'}}>Last Modified Date</TH>
                            </TR>
                        </THead>
                        <TBody>
                            <TR key='history'>
                                <TD>{data?.ticketDetail[0]?.createdBy}</TD>
                                <TD>{data?.ticketDetail[0]?.createdDate && formatDateToDDMMMYYYY(data?.ticketDetail[0]?.createdDate)}</TD>
                                <TD>{data?.ticketDetail[0]?.modifiedBy}</TD>
                                <TD style={{textAlign: 'end'}}>{data?.ticketDetail[0]?.modifiedDate && formatDateToDDMMMYYYY(data?.ticketDetail[0]?.modifiedDate)}</TD>
                            </TR>
                        </TBody>
                    </Table>
                </Card>
            </ContainerDiv>




            <ContainerDiv>
                <Row>
                    <Col size='50'>
                        { data?.ticketDetail[0].fileName && <><Label bold>File Name:</Label> {data.ticketDetail[0].fileName}  ({data.ticketDetail[0].batchNumber})</>}
                    </Col>
                    <Col size='50'>
                        { data?.idocNum && <><Label bold>IDoc Number:</Label> { data.idocNum}</>}
                    </Col>
                </Row>
            </ContainerDiv>
            
            
            <ContainerDiv>
                <span style={{color:'rgb(221, 29, 33)'}}>Note*: </span><span>The attributes displayed on this page are unprocessed raw date received from OpenText, the purpose of this is to accurately display data receiving from OpenText. This details view will be moved into the report section in the future.</span>
            </ContainerDiv>
            <ResponseErrorModal errorDetails={apiErrorResponse} isOpen={apiErrorResponse? true : false} onModalClose={()=>{setApiErrorResponse(null)}}></ResponseErrorModal>
        </>
    )
}

export default RawDetails;